import * as Sentry from "@sentry/react";
import { Amplify } from "aws-amplify";
// biome-ignore lint/correctness/noUnusedImports: this is a react component
import React from "react";
import WithTheme from "./components/theme";
import aws_exports from "./lib/aws_exports";
import RoutesNew from "./routes/index";

Amplify.configure(aws_exports);
const existingConfig = Amplify.getConfig();
Amplify.configure({
  ...existingConfig,
  API: {
    REST: {
      DevApi: {
        endpoint: process.env.API_URL,
        region: process.env.USER_POOL_REGION,
      },
      DevApiPublic: {
        endpoint: process.env.API_URL,
        region: process.env.USER_POOL_REGION,
      },
    },
  },
});

function App() {
  return (
    <WithTheme>
      <RoutesNew />
    </WithTheme>
  );
}

export default Sentry.withProfiler(App);
